import { DEFAULT_API_CONFIG } from './apiConfig';
import queryString from 'query-string';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/client/bundles`;

export const getClientBundles = async queryParams => {
  const q = queryString.stringify(queryParams);
  const url = `${baseRoute}?${q}`;
  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getClientBundleOptions = async (queryParams = {}) => {
  const bundles = await getClientBundles(queryParams);

  const opts = bundles.map(cb => ({
    value: cb.bundleCode,
    label: `(${cb.bundleCode}) - ${cb.name}`,
  }));

  return opts;
};
